module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "indexTwo"
    }
  }, [_c('div', {
    staticClass: "waring-head",
    on: {
      "click": _vm.hqGo
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("提现到活期宝可享3%-6%收益 >")])]), _vm._v(" "), _c('div', {
    staticClass: "content-main"
  }, [_c('div', {
    staticClass: "main-title"
  }, [_c('div', {
    staticClass: "main-title-desc"
  }, [_vm._v("可转入浪票")]), _vm._v(" "), _c('div', {
    staticClass: "main-title-set",
    on: {
      "click": _vm.setting
    }
  }, [_vm._v("设置")])]), _vm._v(" "), _c('div', {
    staticClass: "able-lang-piao"
  }, [_c('div', {
    staticClass: "can-transfer"
  }, [_vm._v("\n        " + _vm._s(_vm.hq.live.availableluckymoney) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "can-transfer-btn-cont"
  }, [_c('div', {
    staticClass: "btn-comm",
    on: {
      "click": function($event) {
        _vm.overTo(_vm.hq.live.availablecash, _vm.hq.live.rate)
      }
    }
  }, [_vm._v("转入活期宝")])])]), _vm._v(" "), _c('div', {
    staticClass: "can-price"
  }, [_vm._v("(" + _vm._s(_vm.hq.live.availablecash) + "元)")]), _vm._v(" "), _c('div', {
    staticClass: "tx-content"
  }, [_c('div', {
    staticClass: "sui-money"
  }, [_c('div', {
    staticClass: "sui-money-jiao sui-money-jiao-right"
  }, [_c('div', {
    staticClass: "sui-money-desc"
  }, [_vm._v("待结算浪票")]), _vm._v(" "), _c('div', {
    staticClass: "sui-money-comm"
  }, [_c('span', {
    staticClass: "sui-money-p"
  }, [_vm._v(_vm._s(_vm.hq.live.frozenluckymoney))]), _c('span')])]), _vm._v(" "), _c('div', {
    staticClass: "sui-money-jiao"
  }, [_c('div', {
    staticClass: "sui-money-desc"
  }, [_vm._v("当前持有浪票")]), _vm._v(" "), _c('div', {
    staticClass: "sui-money-comm"
  }, [_c('span', {
    staticClass: "sui-money-p"
  }, [_vm._v(_vm._s(_vm.hq.live.availableluckymoney + _vm.hq.live.frozenluckymoney))]), _c('span')])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-main"
  }, [_c('div', {
    staticClass: "langhua-jl tx-btn-comm",
    on: {
      "click": function($event) {
        _vm.spray()
      }
    }
  }, [_vm._v("浪票收支记录")]), _vm._v(" "), _c('img', {
    staticClass: "icon-help",
    attrs: {
      "src": require("../../assets/images/icon_help.png")
    }
  }), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), (_vm.isShowHasfundaccount) ? _c('div', {
    staticClass: "content-main hqpord"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "able-lang-piao"
  }, [_c('div', {
    staticClass: "can-transfer hqp-price"
  }, [_vm._v("\n        " + _vm._s(_vm._f("rounding")(Number(_vm.hq.gridData.balance * 100 + _vm.hq.gridData.notconfirminamount * 100 + _vm.hq.gridData.notconfirmoutamount * 100) / 100)) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "can-transfer-btn-cont"
  }, [_c('div', {
    staticClass: "btn-comm hqp-btn-bank",
    on: {
      "click": _vm.cash
    }
  }, [_vm._v("提现到银行卡")])])]), _vm._v(" "), _c('div', {
    staticClass: "can-price"
  }, [_vm._v("[ 转入确认中: " + _vm._s(_vm.hq.gridData.notconfirminamount) + "元 | 提现确认中: " + _vm._s(_vm.hq.gridData.notconfirmoutamount) + "元\n      ]\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "tx-content"
  }, [_c('div', {
    staticClass: "sui-money"
  }, [_c('div', {
    staticClass: "sui-money-jiao sui-money-jiao-right"
  }, [_c('div', {
    staticClass: "sui-money-desc"
  }, [_vm._v("昨日收益 (元)")]), _vm._v(" "), _c('div', {
    staticClass: "sui-money-comm"
  }, [_c('span', {
    staticClass: "sui-money-p"
  }, [_vm._v(_vm._s(_vm._f("rounding")(_vm.hq.gridData.yestdayincome)))]), _c('span')])]), _vm._v(" "), _c('div', {
    staticClass: "sui-money-jiao"
  }, [_c('div', {
    staticClass: "sui-money-desc"
  }, [_vm._v("累计收益")]), _vm._v(" "), _c('div', {
    staticClass: "sui-money-comm"
  }, [_c('span', {
    staticClass: "sui-money-p"
  }, [_vm._v(_vm._s(_vm._f("rounding")(_vm.hq.gridData.totalincome)))]), _c('span')])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-main"
  }, [_c('div', {
    staticClass: "langhua-jl tx-btn-comm"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/profit/hqrecord'
      }
    }
  }, [_vm._v("活期宝收支记录")])], 1), _vm._v(" "), _c('img', {
    staticClass: "icon-help",
    attrs: {
      "src": require("../../assets/images/icon_help.png")
    }
  }), _vm._v(" "), _vm._m(2)])])]) : _vm._e(), _vm._v(" "), (_vm.hq.hasfundaccount === true && _vm.isJb) ? _c('div', {
    staticClass: "content-main hqpord hq-tx-cont",
    on: {
      "click": function($event) {
        _vm.showCash($event)
      }
    }
  }, [_c('div', {
    staticClass: "hq-tx-main"
  }, [_c('div', {
    staticClass: "hq-tx-desc"
  }, [_vm._v("我的活期宝(这里提现)")]), _vm._v(" "), _c('div', {
    staticClass: "right-main"
  }, [_c('span', {
    staticClass: "hq-tx-pri"
  }, [_vm._v(_vm._s(_vm.hq.gridData.internaltotalamount) + "元")]), _vm._v(" "), _c('i', {
    staticClass: "mui-icon mui-icon-arrowright right-icon"
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-main hqpord hq-tx-cont",
    on: {
      "click": _vm.openRed
    }
  }, [_c('div', {
    staticClass: "hq-tx-main"
  }, [_c('div', {
    staticClass: "hq-tx-desc"
  }, [_vm._v("我的红包"), (_vm.redCount > 0) ? _c('span', [_vm._v("("), _c('span', {
    staticClass: "h-bao-tip"
  }, [_vm._v("待领取")]), _vm._v(")")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right-main"
  }, [_c('span', {
    staticClass: "hq-tx-pri"
  }, [_vm._v(_vm._s(_vm.redCount) + "元")]), _vm._v(" "), _c('i', {
    staticClass: "mui-icon mui-icon-arrowright right-icon"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-help"
  }, [_c('div', {
    staticClass: "btn-main-h"
  }, [(_vm.isIos) ? _c('a', {
    staticClass: "txt-comm tell",
    attrs: {
      "href": "tel:021-24099034"
    },
    on: {
      "click": _vm.sendMobile
    }
  }, [_vm._v("客服电话: 021-24099034")]) : _vm._e(), _vm._v(" "), (!_vm.isIos && _vm.androidDisplay) ? _c('a', {
    staticClass: "txt-comm tell",
    attrs: {
      "href": "tel:021-24099034"
    },
    on: {
      "click": _vm.sendMobile
    }
  }, [_vm._v("客服电话: 021-24099034")]) : _vm._e(), _vm._v(" "), (!_vm.isIos && !_vm.androidDisplay) ? _c('a', {
    staticClass: "txt-comm",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("客服电话: 021-24099034")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "word-day"
  }, [_vm._v("工作日：9:00--18:00")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "langhua-hqb tx-btn-comm"
  }, [_c('a', {
    attrs: {
      "href": "http://lvbsns.eastmoney.com/LVBPages/Static/DiamondsHelp.html"
    }
  }, [_vm._v("结算浪票帮助")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-title"
  }, [_c('div', {
    staticClass: "main-title-desc"
  }, [_vm._v("活期宝余额 (元)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "langhua-hqb tx-btn-comm"
  }, [_c('a', {
    staticClass: "jie-comm",
    attrs: {
      "href": "#/tips/question"
    }
  }, [_vm._v("关于活期宝的问题")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-693adab2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/hqpord/original.vue
// module id = 362
// module chunks = 34